// i18n.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// You can import your translations files here
import translationEN from './locales/en/translation.json'
import translationDE from './locales/de/translation.json'

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'de', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
})

export default i18n
